<template>
  <div class="product-card-information">
    <div v-if="rating !== null" class="product-card-information__item">
      <IconRating class="product-card-information__icon" />
      <span>
        {{ rating || $t('product.reviews.newEventLabel') }}
      </span>
    </div>

    <template v-if="tags?.length">
      <div
        v-for="tag in tags"
        :key="tag"
        class="product-card-information__item product-card-information__item--border"
      >
        <span>{{ tag }}</span>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import IconRating from '@/public/icons/rating.svg?component'

const { rating = null, tags = [] } = defineProps<{
  duration?: string
  isDurationVisible?: boolean
  rating?: number | string | null
  isPromoCard?: boolean
  tags?: string[]
}>()
</script>

<style lang="postcss" scoped>
.product-card-information {
  @apply flex gap-1 mb-0 flex-wrap;

  &__item {
    @apply whitespace-nowrap text-xs md:text-sm h-auto md:h-[24px] flex items-center text-center font-normal;
    color: rgba(75, 85, 99, 0.77);
    &--border {
      @apply rounded-lg py-0.5 px-1 md:px-2 mr-0 text-stone-900;
      background: rgba(246, 255, 208, 0.5);
      border: 1px solid rgba(134, 163, 21, 0.6);
    }
  }

  &__icon {
    @apply w-4 h-4 relative top-[-1px] mr-1;
  }
}
</style>
